export const CARD_W_IN = 3.5;
export const CARD_H_IN = 2.0;
export const CARD_ASPECT = `${CARD_W_IN} / ${CARD_H_IN}`;
export const CARD_FORMAT = "AVERY_5871";

export const DEFAULT_CARD_LAYOUT = {
  format: CARD_FORMAT,
  art_x: 0, art_y: 0, art_scale: 1,
  barcode_x: 0.15, barcode_y: 1.20, barcode_w: 2.20, barcode_h: 0.66,
  ticket_id_x: 2.45, ticket_id_y: 1.42, ticket_id_size: 9,
  show_guest_name: false, guest_x: 2.45, guest_y: 1.24, guest_size: 7,
  barcode_white_bg: true,
};

export const SHEET_5871 = {
  orientation: "PORTRAIT", cols: 2, rows: 5, ticket_w: CARD_W_IN, ticket_h: CARD_H_IN,
  margin_x: 0.75, margin_y: 0.5, gap_x: 0, gap_y: 0, content_rotation: 0,
};

export const cardLayout = (layout) =>
  layout?.format === CARD_FORMAT ? { ...DEFAULT_CARD_LAYOUT, ...layout } : { ...DEFAULT_CARD_LAYOUT };

export const artStyle = (L) => ({
  position: "absolute",
  left: `${(Number(L.art_x) / CARD_W_IN) * 100}%`,
  top: `${(Number(L.art_y) / CARD_H_IN) * 100}%`,
  width: `${Number(L.art_scale) * 100}%`,
  height: "auto",
  maxWidth: "none",
});
